import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import Modal from 'components/ui/Modal';
import * as AttemptModule from 'modules/attempt';

interface ResultPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: AttemptModule.Types.IApi.GuestResult.Response;
}

/** Renders the SAME TestResultSummary from the live unsaved form — preview === output, no backend call. */
const ResultPreviewModal: React.FC<ResultPreviewModalProps> = ({ isOpen, onClose, data }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" title={t('result_preview_title')}>
      <div className="space-y-4">
        <div className="flex items-start gap-2 rounded-lg bg-amber-50 p-3 text-sm text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">
          <Info className="mt-0.5 h-4 w-4 shrink-0" />
          <span>{t('result_preview_notice')}</span>
        </div>
        <div className="rounded-lg bg-muted/20 p-4">
          <AttemptModule.TestResultSummary data={data} />
        </div>
      </div>
    </Modal>
  );
};

export default ResultPreviewModal;
